// extracted by mini-css-extract-plugin
export default {"melodyVideo":"gI-z","isFullWidth":"hI-z","landingPageVideo":"iI-z","play":"jI-z","iframeVideo":"kI-z","playHidden":"lI-z","fullwidth":"mI-z"};